import React from "react";
import OrderList from "../../../Common/Components/OrlderList";

const List = () => {
  return <OrderList />;
};

export default List;
